module.exports = "<div class=\"kl-collapse {class}\" is-dis={disabled} r-hide={!visible}>\n    {#inc this.$body}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/_deprecated_/collapse/index.html
// module id = 373
// module chunks = 0